function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Enrollments from './panels/Enrollments';
import ExamRegistrations from './panels/ExamRegistrations';
import Order from './panels/Order';
import Cost from './panels/Cost';
import styles from '../../../sass/status.module.scss';
export default (function (props) {
  var studentRegistrations = props.studentRegistrations,
      examRegistrations = props.examRegistrations,
      cost = props.cost,
      school = props.school,
      history = props.history,
      hideOrderPanel = props.hideOrderPanel,
      hideStudentRegistrations = props.hideStudentRegistrations;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['status-panel-container']
  }, !hideStudentRegistrations ? /*#__PURE__*/React.createElement(Enrollments, studentRegistrations) : null, /*#__PURE__*/React.createElement(ExamRegistrations, _extends({}, examRegistrations, {
    history: history
  })), /*#__PURE__*/React.createElement(Cost, cost), !hideOrderPanel ? /*#__PURE__*/React.createElement(Order, _extends({}, examRegistrations, school, {
    history: history
  })) : null);
});